/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * UserRoleStyled tabs
 *
 * @file UserRoleStyledTabs.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';

const UserRoleStyledTabs = withStyles((theme) => ({
  root: {
    background: theme.color.background,
    color: theme.color.textPrimary
  },
  indicator: {
    background: theme.color.activePrimary,
    borderRadius: 15,
    height: 3
  }
}))(Tabs);

export default UserRoleStyledTabs;
